import React, { useContext } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ThemeContext } from '../../../../../utils/themeContext';
import { AppContext } from '../../../../../utils/appContext';

const BankTransfer = () => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation();
  let history = useHistory();

  const theme = useContext(ThemeContext);

  const useStyles = makeStyles()((theme) => {
    return {
      paymentContainer: {
        textAlign: 'center',
        padding: '6px 0',
        cursor: 'pointer',
        minHeight: 20,
        display: 'flex',
        backgroundColor: '#ffffff',
        border: '1px solid #555',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px!important',
        '&:hover': {
          borderColor: theme.palette.primary.main
        },
        '& i': {
          fontSize: 30,
          alignItems: 'center',
          display: 'inline-flex'
        },
        '& img': {
          alignItems: 'center',
          display: 'flex'
        }
      }
    };
  });

  const { classes } = useStyles();

  return (
    <Grid item xs={12}>
      <Box sx={{ marginBottom: 5 }}>
        <Grid container direction="row" justifyContent="center" alignItems="flex-start">
          <Box sx={{ width: '100%' }}>
            <Paper className={classes.paymentContainer}>
              <Typography component={'p'} variant={'h6'}>
                {t('Conferma e procedi')}
              </Typography>
            </Paper>
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};

export default BankTransfer;
